import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@core/modules/shared.module';
import { OwnerShipListComponent } from './ownership-list/ownership-list.component';
import { OwnerShipDetailComponent } from './ownership-detail/ownership-detail.component';
import { AppProgressStepsComponent } from './ownership-detail/probress-steps/probress-steps.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { OwnerShipService } from './ownership.services';
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 'auto'
};

const routes = [
    {
        path     : 'list',
        component: OwnerShipListComponent,
        resolve  : {
            ownership: OwnerShipService
        }
    },
    {
        path     : 'list/:id',
        component: OwnerShipDetailComponent,
        resolve  : {
            ownership: OwnerShipService
        }
    }
];

@NgModule({
    declarations: [
        AppProgressStepsComponent,
        OwnerShipListComponent,
        OwnerShipDetailComponent
    ],
    imports : [
        SharedModule,
        SwiperModule,
        RouterModule.forChild(routes)
    ],
    providers: [
        OwnerShipService,
        {
          provide: SWIPER_CONFIG,
          useValue: DEFAULT_SWIPER_CONFIG
        }
      ]
})

export class OwnershipModule
{
}
